import RenderQ from "./RenderQ";

const AnsweredQuestions = ({ questArray }) => {
  return <RenderQ questArray={questArray} />;
};

export default AnsweredQuestions;
